import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
export default defineComponent({
    name: 'ForgotPassword',
    setup() {
        const email = ref('');
        const errorMessage = ref('');
        const router = useRouter();
        const handleLogin = () => {
            if (!email.value) {
                errorMessage.value = 'Please enter your email.';
                return;
            }
            errorMessage.value = '';
            router.push('/create-password');
        };
        return {
            email,
            errorMessage,
            handleLogin
        };
    }
});
